// D5: the single source of truth for the user-grantable internal toolsets.
//
// Before this, every picker hand-rolled its own list and they drifted:
// ExpertWizard omitted `analytics`-parity metadata, WiringTab omitted
// `analytics` entirely, so the same agent showed a different set of toggles
// depending on which surface you edited it from.
//
// This catalog is the general-purpose set a tenant developer may grant to an
// agent. It is a subset of the backend allowlist
// `_USER_GRANTABLE_TOOLSETS` (graph_nodes.py): the backend set additionally
// contains `demo` (mock CRM/JIRA, provisioned only by the Demo Agent
// bootstrap — never a user toggle) while `builder`/`tester`/`admin` are
// privileged and reachable only via admin-gated agent flags. Keep the names
// here in sync with that backend allowlist minus `demo`.
export const TOOLSET_CATALOG = [
  {
    name: "query",
    label: "Query (SQL/graph/vector)",
    description:
      "Smart Query Router (SQL / Graph / Vector) for structured + unstructured data. Useful for data analyst-style agents.",
    tools: ["query_data", "query_sql", "list_data_tables"],
  },
  {
    name: "analysis",
    label: "Analysis (map-reduce, summaries)",
    description:
      "Map-reduce document analysis, metadata SQL queries, and corpus stats. Layer on top of query for cross-document reasoning.",
    tools: ["analyze_documents", "query_document_metadata", "get_document_stats"],
  },
  {
    name: "communication",
    label: "Communication (email + SMS)",
    description: "Send email + SMS via the tenant's SMTP / Twilio config.",
    tools: ["send_email", "send_sms"],
  },
  {
    name: "approvals",
    label: "Approvals (human-in-the-loop)",
    description:
      "Human-in-the-loop pending actions. Agent proposes an action; supervisor approves/rejects via the Supervisor Dashboard.",
    tools: ["propose_action", "list_pending_approvals", "get_approval_stats"],
  },
  {
    name: "analytics",
    label: "Analytics (cross-agent KPIs)",
    description:
      "Cross-agent performance data — list agents and read their KPIs. Auto-injected for Dynamic / Super agents; grantable to any agent.",
    tools: ["list_agents", "get_agent_performance", "get_all_performance"],
  },
  {
    // code_interpreter is user-grantable, but running code is gated on the
    // workspace Executable Skills opt-in (Admin → Executable Skills). Consumers
    // that can read the flag render it disabled with a hint when off.
    name: "code_interpreter",
    label: "Code interpreter (run Python → files)",
    description:
      "Write + run Python on the fly over the agent's own data (Excel / PPTX / PDF / charts).",
    tools: ["run_code"],
    requiresFlag: "executable_skills_enabled",
  },
];

// The canonical set of names — the one list every picker agrees on.
export const USER_GRANTABLE_TOOLSET_NAMES = TOOLSET_CATALOG.map((t) => t.name);
